import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "d-flex flex-column" };
const _hoisted_2 = { class: "social-icons social-icons-lg social-icons-colored justify-content-center" };
const _hoisted_3 = { class: "social-icons-facebook" };
const _hoisted_4 = ["href"];
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("i", { class: "fab fa-facebook-f" }, null, -1);
const _hoisted_6 = [
    _hoisted_5
];
const _hoisted_7 = { class: "social-icons-twitter" };
const _hoisted_8 = ["href"];
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("i", { class: "fab fa-twitter" }, null, -1);
const _hoisted_10 = [
    _hoisted_9
];
const _hoisted_11 = { class: "social-icons-whatsapp" };
const _hoisted_12 = ["href"];
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("i", { class: "fab fa-whatsapp" }, null, -1);
const _hoisted_14 = [
    _hoisted_13
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
            _createElementVNode("li", _hoisted_3, [
                _createElementVNode("a", {
                    "data-toggle": "tooltip",
                    href: 'https://facebook.com/sharer/sharer.php?u=' + _ctx.url,
                    target: "_blank",
                    title: "",
                    "data-original-title": "Facebook"
                }, _hoisted_6, 8, _hoisted_4)
            ]),
            _createElementVNode("li", _hoisted_7, [
                _createElementVNode("a", {
                    "data-toggle": "tooltip",
                    href: 'https://twitter.com/intent/tweet?text=' + _ctx.text,
                    target: "_blank",
                    title: "",
                    "data-original-title": "Twitter"
                }, _hoisted_10, 8, _hoisted_8)
            ]),
            _createElementVNode("li", _hoisted_11, [
                _createElementVNode("a", {
                    "data-toggle": "tooltip",
                    href: 'https://api.whatsapp.com/send?text=' + _ctx.text,
                    target: "_blank",
                    title: "",
                    "data-original-title": "Whatsapp"
                }, _hoisted_14, 8, _hoisted_12)
            ])
        ])
    ]));
}
